import * as jsxRuntime from "/Users/clinton/pcode/repos/peekapak-platform.release-2026.06.17/apps/frontend/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment